export const PAGE_SIZE = 7;
export const PAGE_SIZES = [7, 19, 39];
export const PAGE_NUMBER = 1;
export const BY_PAGE_TEXT = 'Помещений на странице'


// WEBPACK FOOTER //
// ./src/pages/organizations/card/spaces/const.ts